import ItineraryLeg from './ItineraryLeg'

export default ItineraryLeg;